let dirPath = 'static/games/page003_game4';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook3' }],
          },
          {
            idGroup: 'source',
            idItem: '04',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook4' }],
          },
          {
            idGroup: 'source',
            idItem: '05',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook5' }],
          },
          {
            idGroup: 'source',
            idItem: '06',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook6' }],
          },
          {
            idGroup: 'source',
            idItem: '07',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook7' }],
          },
          {
            idGroup: 'source',
            idItem: '08',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook8' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { textAlign: 'center', bold: true },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 850, width: 1800 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#cc000001',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 213 },
                },
                items: [
                  {
                    id: 'hook3',
                    positions: { pos: { x: 1130, y: 718, height: 84, width: 163 } },
                    //
                  },
                  {
                    id: 'hook4',
                    positions: { pos: { x: 48, y: 52, height: 431, width: 232 } },
                    //
                  },
                  {
                    id: 'hook5',
                    positions: { pos: { x: 1130, y: 53, height: 333, width: 438 } },
                    //
                  },
                  {
                    id: 'hook6',
                    positions: { pos: { x: 580, y: 374, height: 325, width: 348 } },
                    //
                  },
                  {
                    id: 'hook7',
                    positions: { pos: { x: 497, y: 722, height: 75, width: 510 } },
                    //
                  },
                  {
                    id: 'hook8',
                    positions: { pos: { x: 48, y: 600, height: 196, width: 198 } },
                    //
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 0, y: 0 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            type: 'absolute',
            autoFit: true,
          },
        },
        items: [
          {
            id: '05',
            positions: {
              pos: { x: 410, y: 100, height: 333, width: 438 },
            },
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
          },
          {
            id: '06',
            positions: {
              pos: { x: 1420, y: 480, height: 325, width: 348 },
            },
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
          },
          {
            id: '07',
            positions: {
              pos: { x: 90, y: 520, height: 75, width: 510 },
            },
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
          },
          {
            positions: {
              pos: { x: 980, y: 30, height: 431, width: 232 },
            },
            id: '04',
            background: {
              image: { src: dirPath + '/img/03.png' },
            },
          },
          {
            positions: {
              pos: { x: 400, y: 680, height: 84, width: 163 },
            },
            id: '03',
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
          },
          {
            positions: {
              pos: { x: 1100, y: 500, height: 196, width: 198 },
            },
            id: '08',
            background: {
              image: { src: dirPath + '/img/05.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  //   realHeight: 790,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      y: 0,
      x: 0,
    },
  },

  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
